import React from 'react';

interface BadgeProps {
    badgeClasses?: string;
    badgeText?: string;
    badgeIcon?: React.ReactNode;
    badgeIconPosition?: 'left' | 'right';
    /** Matches `Btn` sizing — applies `btn-sm`, `btn-md`, or `btn-lg`. */
    buttonSize?: 'sm' | 'md' | 'lg';
}

const Badge = (props: BadgeProps) => {
    const { badgeClasses, badgeText, badgeIcon, badgeIconPosition = 'left', buttonSize } = props;

    const className = ['badge', buttonSize ? `btn-${buttonSize}` : undefined, badgeClasses].filter(Boolean).join(' ');
    const leftIcon = Boolean(badgeIcon) && badgeIconPosition === 'left';
    const rightIcon = Boolean(badgeIcon) && badgeIconPosition === 'right';

    return (
        <span className={className}>
            {leftIcon && badgeIcon}
            {badgeText}
            {rightIcon && badgeIcon}
        </span>
    );
};

export default Badge;
